module.exports = __webpack_public_path__ + "img/lucky_banner.9df1a0e1.png";